import {
  AuthB2BRequestOtpBodyType,
  AuthB2BRequestOtpResponseType
} from "@website/widget/login/services/auth-b2b-request-otp/auth-b2b-request-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const AuthB2BRequestOtpUrl = `${BASE_URL_PROFILE}/b2b/auth/request-otp`;

export const AuthB2BRequestOtpService = (
  body: AuthB2BRequestOtpBodyType
): Promise<AuthB2BRequestOtpResponseType> =>
  Axios.post(AuthB2BRequestOtpUrl, body).then(
    ({ data }: AxiosResponse<AuthB2BRequestOtpResponseType>) => data
  );
